import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { LoadingBar, MetricCard, PageTitleWithToolTip, Select } from '../../components/Common';
import { createYearValues } from '../../utils';
import Routes from '../../routes';
import { mediumGray, darkestGray } from '../../color_utils';

const labelSx = { fontFamily: 'Inter', fontWeight: 400, fontSize: '16px', lineHeight: '23px', color: mediumGray };
const valueSx = { fontFamily: 'Inter', fontWeight: 600, fontSize: '32px', lineHeight: '46px', color: darkestGray };

const InsightsPage = () => {
    const [loading, setLoading] = useState(true);
    const [metrics, setMetrics] = useState(null);
    const [year, setYear] = useState({
        id: new Date().getFullYear(),
        label: `${new Date().getFullYear()}`,
    });

    const yearValues = createYearValues();

    const fetchMetrics = async (selectedYear) => {
        setLoading(true);
        try {
            const response = await fetch(Routes.Insights.GetMetrics(), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ year: selectedYear.id }),
            });
            const data = await response.json();
            setMetrics(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching insights metrics:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMetrics(year);
    }, []);

    const metricCards = [
        { label: 'Corporate Leak Rate', value: metrics?.corporateLeakRate != null ? `${parseFloat(metrics.corporateLeakRate).toFixed(1)}%` : '—' },
        { label: 'Refrigerant Usage', value: metrics?.installGasAmount != null ? Math.round(metrics.installGasAmount) : '—' },
        { label: 'AVG Days to Enter Service', value: metrics?.daysToEnterService != null ? Math.round(metrics.daysToEnterService) : '—' },
        { label: 'Appliances Affected by Leaks', value: metrics?.appliancesAffectedByLeaks != null ? `${parseFloat(metrics.appliancesAffectedByLeaks).toFixed(1)}%` : '—' },
        { label: 'GHGp (in MTCO2e)', value: metrics?.ghgpInMtco2e != null ? metrics.ghgpInMtco2e : '—' },
    ];

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PageTitleWithToolTip
                    pageTitle={"\u{1F4CA} Insights"}
                    toolTipText={'High-level dashboard that showcased key data, enabling managers to grasp activities affecting compliance and track sustainability goals more effectively.'}
                />
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ width: { xs: '100%', sm: 300 } }}>
                    <Select
                        label="Year"
                        value={String(year.id)}
                        options={yearValues}
                        width={100}
                        onChange={(e) => {
                            const val = { id: Number(e.target.value), label: String(e.target.value) };
                            setYear(val);
                            fetchMetrics(val);
                        }}
                    />
                </Box>
            </Grid>
            {loading ? (
                <Grid item xs={12}>
                    <LoadingBar />
                </Grid>
            ) : (
                metricCards.map(({ label, value }) => (
                    <Grid item xs={12} sm={6} md={true} key={label}>
                        <MetricCard label={label} value={value} labelSx={labelSx} valueSx={valueSx} />
                    </Grid>
                ))
            )}
        </Grid>
    );
};

export default InsightsPage;
